<p *ngFor="let notification of notifications">
    <ngb-alert [type]="getType(notification)" (close)="close(notification)" [innerHtml]="notification.message | safe:'html'"></ngb-alert>
</p>